import { render, staticRenderFns } from "./ConfigurationCompanyProfileCard.vue?vue&type=template&id=efcd1338&scoped=true&"
import script from "./ConfigurationCompanyProfileCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationCompanyProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efcd1338",
  null
  
)

export default component.exports